import App from '../index.js';
import { isEmpty } from 'lodash';
import { amplitudeEvents } from '../amplitude';
import Chart from 'chart.js/auto';
import select2 from 'select2';
select2(window, $);


App.SurveyAnalytics = (function () {
    const organizationId = window.AMPLITUDE_BOOT?.organization_id || null;
    const surveyId = window.AMPLITUDE_BOOT?.survey_id || null;
    const amplitude = amplitudeEvents();

    function lineGraphInit () {
        let el = $('#lineGraph');

        const labels = el.data('labels') || [];
        const datasets = el.data('datasets') || [];

        const data = {
            labels: labels,
            datasets: datasets
        };

        const config = {
            type: 'line',
            data: data,
            responsive: true,
            maintainAspectRatio: false,

            options: {
                plugins: {
                    legend: {
                        align: 'end',
                        labels: {
                            padding: 20,
                            boxWidth: 10,
                            boxHeight: 10,
                        }
                    },
                },
                scales: {
                    y: {
                        suggestedMax: 10
                    }
                }
            }
        };

        if (labels.length && datasets.length) {
            new Chart(
                el,
                config
            );
        }
    }

    function initDatePicker () {
        $('#start_date').on('change', function ( e ) {
            var startDate = $(this).val();
            $('#end_date').attr('min', startDate);
        });
    }

    function languageChange () {
        amplitude.trackLanguageFilter($('#language_selector').val(), {
            organization_id: organizationId,
            survey_id: surveyId
        });
        $('#filter_form')[0].submit();
    }

    function printCss () {
        $('.print-analytics-page-wrapper').css('max-width', '800px');
        $('.print-line-graph').css('width', '780px');
    }

    function handleDeleteSurveyResponse() {
        $('#deleteSurveyResponse form').attr('action', $(this).data('url'));
    }

    function trackAnalyticsLoaded() {
        amplitude.trackAnalyticsLoaded('always_on_analytics_loaded_survey_' + surveyId, {
            organization_id: organizationId,
            survey_id: surveyId
        });
    }

    function triggerAmplitudeEvents() {
        trackAnalyticsLoaded();
    }

    return {
        init: function () {
            lineGraphInit();
            initDatePicker();
            triggerAmplitudeEvents();
            $('[data-toggle="tooltip"]').tooltip();

            $('body')
                .on('change', '#language_selector', languageChange)
                .on('click', '.delete-survey-response', handleDeleteSurveyResponse)
                .on('click', '.print-button', function () {
                    printCss();
                    setTimeout(() => {
                        window.print();
                        amplitude.trackPrint({
                            organization_id: organizationId,
                            survey_id: surveyId
                        });
                    }, 200);
                });

            window.onbeforeprint = ( event ) => {
                printCss();
            };

            window.onafterprint = ( event ) => {
                $('.print-analytics-page-wrapper, .print-circular-graph, .print-line-graph').removeAttr('style');
            };
        }
    };

})();

// Provide the route name
App.registerRoute('organizations.surveys.analytics', App.SurveyAnalytics.init);

export default App.BotAnalytics;
